export enum HttpStatusCodes {
  OK = 200,
  CREATED = 201,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
}

export enum ApiErrorCodes {
  APP_UPGRADE_REQUIRED = "APP_UPGRADE_REQUIRED",
  AUTH_KEY_INVALID_OR_EXPIRED = "AUTH_KEY_INVALID_OR_EXPIRED",
  CAPTCHA_ERROR = "CAPTCHA_ERROR",
  EMAIL_ALREADY_REGISTERED = "EMAIL_ALREADY_REGISTERED",
  EMAIL_ALREADY_VERIFIED = "EMAIL_ALREADY_VERIFIED",
  EMAIL_IS_BLOCKED = "EMAIL_IS_BLOCKED",
  EMAIL_IS_NOT_VERIFIED = "EMAIL_IS_NOT_VERIFIED",
  OTP_CHECK_FAILED = "OTP_CHECK_FAILED",
  PHONE_ALREADY_USED = "PHONE_ALREADY_USED",
  PHONE_VERIFICATION_CODE_NOT_FOUND = "PHONE_VERIFICATION_CODE_NOT_FOUND",
  SMS_AERO_ERROR = "SMS_AERO_ERROR",
  TWILIO_ERROR = "TWILIO_ERROR",
  USER_ALREADY_DELETED = "USER_ALREADY_DELETED",
  USER_BLOCKED = "USER_BLOCKED",
  USER_DELETED = "USER_DELETED",
  USER_WITH_EMAIL_IS_DELETED = "USER_WITH_EMAIL_IS_DELETED",
  VERIFICATION_CODE_NOT_FOUND = "VERIFICATION_CODE_NOT_FOUND",
  VERIFIED_PHONE_NOT_FOUND = "VERIFIED_PHONE_NOT_FOUND",
  WRONG_PASSWORD = "WRONG_PASSWORD",
  USERNAME_ALREADY_USED = "USERNAME_ALREADY_USED",
  RECAPTCHA_NOT_CONFIGURED = "RECAPTCHA_NOT_CONFIGURED",
  RECAPTCHA_TOKEN_MISSING = "RECAPTCHA_TOKEN_MISSING",
  RECAPTCHA_VERIFICATION_FAILED = "RECAPTCHA_VERIFICATION_FAILED",
  RECAPTCHA_SCORE_TOO_LOW = "RECAPTCHA_SCORE_TOO_LOW",
  TOTP_REQUIRED = "TOTP_REQUIRED",
  TOTP_VERIFICATION_FAILED = "TOTP_VERIFICATION_FAILED",
  TOTP_ALREADY_ENABLED = "TOTP_ALREADY_ENABLED",
  TOTP_NOT_ENABLED = "TOTP_NOT_ENABLED",
  TOTP_INVALID_SECRET = "TOTP_INVALID_SECRET",
}

const ERROR_MESSAGES: Record<ApiErrorCodes, string> = {
  [ApiErrorCodes.APP_UPGRADE_REQUIRED]:
    "Действие недоступно. Обновите приложение.",
  [ApiErrorCodes.AUTH_KEY_INVALID_OR_EXPIRED]:
    "Невалидный или истёкший ключ авторизации",
  [ApiErrorCodes.CAPTCHA_ERROR]: "Ошибка обработки капчи",
  [ApiErrorCodes.EMAIL_ALREADY_REGISTERED]:
    "Пользователь с таким email уже зарегистрирован",
  [ApiErrorCodes.EMAIL_ALREADY_VERIFIED]: "Email уже подтверждён",
  [ApiErrorCodes.EMAIL_IS_BLOCKED]: "Email заблокирован",
  [ApiErrorCodes.EMAIL_IS_NOT_VERIFIED]: "Email не подтверждён",
  [ApiErrorCodes.OTP_CHECK_FAILED]: "Одноразовый пароль не подходит",
  [ApiErrorCodes.PHONE_ALREADY_USED]:
    "Телефон уже используется в другом аккаунте",
  [ApiErrorCodes.PHONE_VERIFICATION_CODE_NOT_FOUND]:
    "Код верификации телефона не найден",
  [ApiErrorCodes.SMS_AERO_ERROR]: "Ошибка отправки запроса в SMS-AERO",
  [ApiErrorCodes.TWILIO_ERROR]: "Ошибка отправки запроса в Twilio",
  [ApiErrorCodes.USER_ALREADY_DELETED]: "Пользователь уже удалён",
  [ApiErrorCodes.USER_BLOCKED]: "Пользователь заблокирован",
  [ApiErrorCodes.USER_DELETED]: "Пользователь удалён",
  [ApiErrorCodes.USER_WITH_EMAIL_IS_DELETED]:
    "Пользователь с таким email удалён",
  [ApiErrorCodes.VERIFICATION_CODE_NOT_FOUND]: "Код проверки не найден",
  [ApiErrorCodes.VERIFIED_PHONE_NOT_FOUND]:
    "Пользователь с указанным подтвержденным телефоном не найден",
  [ApiErrorCodes.WRONG_PASSWORD]: "Пароль не подходит",
  [ApiErrorCodes.USERNAME_ALREADY_USED]: "Имя пользователя уже используется",
  [ApiErrorCodes.RECAPTCHA_NOT_CONFIGURED]: "Recaptcha не настроена",
  [ApiErrorCodes.RECAPTCHA_TOKEN_MISSING]: "Отсутствует токен Recaptcha",
  [ApiErrorCodes.RECAPTCHA_VERIFICATION_FAILED]: "Ошибка проверки Recaptcha",
  [ApiErrorCodes.RECAPTCHA_SCORE_TOO_LOW]: "Слишком низкий рейтинг Recaptcha",
  [ApiErrorCodes.TOTP_REQUIRED]: "Требуется код аутентификации",
  [ApiErrorCodes.TOTP_VERIFICATION_FAILED]: "Неверный код аутентификации",
  [ApiErrorCodes.TOTP_ALREADY_ENABLED]:
    "Двухфакторная аутентификация уже включена",
  [ApiErrorCodes.TOTP_NOT_ENABLED]: "Двухфакторная аутентификация не включена",
  [ApiErrorCodes.TOTP_INVALID_SECRET]: "Недействительный секретный ключ",
};

export function getErrorMessage(error: any): string {
  const errorCode = error.response?.data?.code || error.data?.code;

  if (errorCode && ERROR_MESSAGES[errorCode as ApiErrorCodes]) {
    return ERROR_MESSAGES[errorCode as ApiErrorCodes];
  }

  return (
    error.response?.data?.detail ||
    error.data?.detail ||
    error.message ||
    "Произошла ошибка"
  );
}
